// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3LKlI","colCheckbox":"styles_colCheckbox__2hF23"};